import { Permission } from "./user-permission";

export class AppUserModel {
    public id: string;
    public name: string;
    public email: string;
    public firstName: string;
    public lastName: string;
    public permissions: Permission;

    constructor(data?: any) {
        if (data) {
            this.cast(data);
        }
    }

    private cast(data) {
        this.id = data.id;
        this.name = data.name;
        this.email = data.email;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.permissions = data.permissions
    }
}
